import moment from 'moment'

export function countSunday(startDateMoment: moment.Moment, endDateMoment: moment.Moment) {
  const current = startDateMoment.clone()
  const result: string[] = []
  while (current.day(7).isSameOrBefore(endDateMoment)) {
    result.push(current.format('YYYY-MM-DD'))
  }
  return result
}
